<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      app
    >
    <v-list>
      <template v-for="(item, i) in menuItems">
        <v-row v-if="item.heading" :key="i" align="center">
          <v-col cols="6">
            <v-subheader v-if="item.heading">
              {{ item.heading }}
            </v-subheader>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn small text>edit</v-btn>
          </v-col>
        </v-row>
        <v-divider v-else-if="item.divider" :key="i" dark class="my-4"></v-divider>
        <v-list-item v-else-if="item.action === 'settings'" :key='item.title' @click="showSettingsDialog = true">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else :key='item.title' :to='item.link'>
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider dark class="my-4"></v-divider>
      <v-list-item key="version">
          <v-list-item-content>
            <v-list-item-title class="grey--text">
              App Version: {{ version }} - {{isFV}}
            </v-list-item-title>
          </v-list-item-content>
      </v-list-item>
    </v-list>
    </v-navigation-drawer>
    <v-app-bar app elevate-on-scroll clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to='/' tag='span' style='cursor: pointer'>
          <span >FirstVue {{isFV}}</span>
          <!-- <img src="@/assets/vnfbay-logo.png" alt=""> -->
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-menu
        left
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="onLogout">
            <v-list-item-action>
                <v-icon>mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Sign out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu> -->
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
    <!-- <settings-dialog :model="showSettingsDialog" :didCancel="didCancelSettings" :didSubmit="didSubmitSettings"></settings-dialog> -->
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  computed: {
    isFV () {
      return localStorage.getItem('fv')
    }
  },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    drawer: null,
    dialogSettings: false,
    showSettingsDialog: false,
    menuItems: [
      { icon: 'mdi-account', title: 'Account', link: '/account/' },
      { divider: true },
      { icon: 'mdi-settings', title: 'Settings', action: 'settings' },
      { icon: 'mdi-settings', title: 'Feedback', link: '/feedback' },
      { divider: true },
      { icon: 'mdi-logout', title: 'Sign out', link: '/signout' }
    ]
  }),
  methods: {
    goHome () {
      this.$router.push('/')
    },
    didCancelSettings () {
      this.showSettingsDialog = false
    },
    didSubmitSettings () {
      this.showSettingsDialog = false
    }
  }
}
</script>
